var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 90,
    viewBox: "0 0 106 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8374_33814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -4,
    width: 106,
    height: 97
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6571 14.3296C13.4352 17.5347 9.39618 21.149 6.42032 25.5885C-14.341 56.5442 27.6478 75.4798 47.9037 84.0351C55.9206 87.4216 64.2992 90.0754 72.9785 91.6513C76.5164 92.2916 80.1676 92.7576 83.8188 92.0853C92.1843 90.545 99.1904 83.0888 102.393 74.8288C105.6 66.5722 105.587 57.6434 104.654 49.177C103.412 37.879 100.611 26.9047 96.3627 16.6739C93.9271 10.8079 90.8597 4.99879 85.8187 1.38812C81.0869 -2.00199 75.0263 -3.14033 69.0441 -3.368C68.2336 -3.40002 67.4189 -3.41425 66.6085 -3.41425C49.5245 -3.41425 32.0702 3.38377 17.6571 14.3332",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8374_33814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.642 -19.7531H-45.293V107.46H160.642V-19.7531Z",
    fill: "#E3D6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7661 17.5276C59.7685 16.9371 55.5465 16.5778 50.6274 17.4956C48.6014 17.8727 47.0938 16.0016 48.3399 14.6427L50.1351 12.6897C50.8888 11.868 51.9476 11.2597 53.1588 10.9822C54.723 10.6265 57.054 10.3775 59.7249 11.0107C60.9231 11.2952 61.9731 11.8964 62.7225 12.7111L64.4087 14.5502C65.2975 15.5178 64.2083 17.8122 62.7661 17.5276Z",
    fill: "#9870B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7764 67.0953L45.4818 73.9361C45.4818 56.9321 63.0581 36.0756 66.8618 22.5756C67.5938 19.9788 66.8923 17.2539 64.936 15.1231L62.7226 12.7112C62.4351 12.3982 62.1039 12.1171 61.738 11.8752C61.4765 23.4863 41.408 46.7938 36.9725 59.9665C36.1404 62.4388 36.8201 65.089 38.7807 67.0918",
    fill: "#AA86C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8592 59.9664C71.4237 46.7902 51.3421 23.472 51.0938 11.8645C50.7365 12.1064 50.4097 12.3839 50.1309 12.6898L47.8957 15.123C45.9394 17.2538 45.2379 19.9787 45.9699 22.5756C49.7736 36.0791 67.3499 56.932 67.3499 73.936L74.0554 67.0953C76.0204 65.0925 76.7001 62.4423 75.8635 59.9664",
    fill: "#B695CE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerSupport);
export default __webpack_public_path__ + "static/media/CancerSupport.033cacbc26f6434c01ec559efe9c1ca0.svg";
export { ForwardRef as ReactComponent };